<template>
    <div class="w-screen bg-gray-100">
        
        <FlashMessages></FlashMessages>
        
        <div class="fixed top-0 left-0 mt-2 ml-2 z-10" v-if="selected_delivery===null">
            <template v-for="territory in territories" >
                <div v-if="selected_territory === null || selected_territory===territory.id" class="mb-2 bg-white px-4 py-2 rounded" @click="selectTerritory(territory.id)">
                    {{ territory.name }}
                </div>

            </template>

            <div v-if="selected_territory !== null" class="mb-2 text-white bg-indigo-700 px-4 py-2 rounded" @click="selectTerritory(null)">
                Afficher tout
            </div>
            
        </div>
        
      
        
        <gmap-map v-if="ready"
            ref="mapRef"
            :center="{lat:45.786643, lng:-74.02221}"
            :options="{mapTypeControl: false, streetViewControl: false, styles: styles}"
            :zoom="12"
            map-type-id="terrain"
            :style="{width: '100%', height: height}"
        >

            <template v-if="selected_delivery">
                <gmap-marker
                    :position="selected_delivery.customer.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="user"

                    @click="selectDelivery(null)"
                />
                <gmap-marker
                    :position="selected_delivery.restaurant.position"
                    :clickable="true"
                    :draggable="false"
                    :icon="merchant"

                    @click="selectDelivery(null)"
                />
            </template>
            <template v-else>
                <gmap-marker
                    :key="`customer_${index}`"
                    v-for="(m, index) in filtered_deliveries"
                    :position="m.customer.position"
                    :clickable="true"
                    :draggable="false"
                    :label="marker_label(m)"
                    :icon="marker_icon(m)"
                    @click="selectDelivery(m)"
                />
            </template>
            

        </gmap-map>

        <div v-if="selected_delivery" class="" >
                <div class="flex items-end justify-center ">

                    <div
                        class="inline-block align-bottom bg-white bg-opacity-80 rounded-lg px-4 pt-5 pb-4 text-left overflow-hidden  transform transition-all sm:my-8 sm:align-middle sm:max-w-sm sm:w-full sm:p-6">
                        <div>
                            <div class="mt-3 text-center sm:mt-5">
                                <h3 class="text-lg leading-6 font-medium text-gray-900" id="modal-title">
                                    {{ selected_delivery.restaurant.name }}
                                    <span class="inline-flex items-center px-2.5 py-0.5 rounded-full text-xs font-medium bg-blue-100 text-blue-800">{{ selected_delivery.territory.name }}</span>
                                </h3>
                                <div class="mt-2">
                                    <p class="text-gray-900 font-bold mb-2">
                                        {{ selected_delivery.order_id }} (${{ selected_delivery.amount.toFixed(2) }})
                                    </p>
                                    <p class="text-gray-900 font-medium mb-2">
                                        {{ selected_delivery.customer.address }}
                                    </p>

                                    <p class="text-xl text-red-600 font-bold mb-2">
                                        {{ selected_delivery.time }}
                                    </p>

                                    <p class="text-lg font-bold text-gray-900 mb-2">
                                        {{ distance(selected_delivery.distance) }}
                                    </p>


                                    <p class="text-gray-900 mb-2">
                                        ${{ selected_delivery.earning.toFixed(2) }} +
                                        <span class="inline-flex items-center px-2.5 py-0.5 rounded-md text-sm font-medium bg-green-100 text-green-800">
                                      ${{ selected_delivery.bonus.toFixed(2) }}
                                    </span>

                                    </p>


                                    <p class="text-sm text-gray-900">
                                        <template v-if="selected_delivery.orders === 1">
                                            CE CLIENT EST UN NOUVEAU CLIENT
                                        </template>
                                        <template v-else>
                                            Ce client a commandé {{ selected_delivery.orders }}  fois
                                        </template>
                                    </p>


                                </div>
                            </div>
                        </div>
                        <div class="mt-5 sm:mt-6">
                            <button @click="conf" type="button"
                                    :class="confirming?'bg-indigo-800':'bg-indigo-600'"
                                    class="inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2  text-base font-medium text-white hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500 sm:text-sm">
                                <template v-if="confirming">
                                    Confirmer saisie?
                                </template>
                                <template v-else>
                                    Saisir commande
                                </template>
                            </button>

                            <button @click="selectDelivery(null)" type="button"
                                    class="mt-2 inline-flex justify-center w-full rounded-md border border-transparent shadow-sm px-4 py-2 bg-gray-300 text-base font-medium text-gray-900 hover:bg-gray-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-500 sm:text-sm">
                                Annuler
                            </button>
                        </div>
                    </div>
               
            </div>

        </div>
    </div>
</template>

<script>




import user from "../../../images/user.png";
import user_red from "../../../images/user-red.png";
import merchant from "../../../images/merchant.png";
import FlashMessages from "../../Shared/FlashMessages";
import RoutePlotter from "../../Shared/lib/RoutePlotter";
import Vue from "vue";

export default {
    name: "Sniper",
    props: [ 'deliveries', 'extras', 'driver'],
    components: {FlashMessages},
    data() {
        
        return {
            user: user,
            user_red: user_red,
            merchant: merchant,
            height: window.innerHeight + "px",
            lines: [],
            selected_delivery: null,
            selected_territory: null,
            confirming: false,
            ready: false,
            previous_bounds: null,
            styles: [
                {
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#242f3e"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#746855"
                        }
                    ]
                },
                {
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#242f3e"
                        }
                    ]
                },
                {
                    "featureType": "administrative.locality",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#d59563"
                        }
                    ]
                },
                {
                    "featureType": "poi",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#d59563"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#263c3f"
                        }
                    ]
                },
                {
                    "featureType": "poi.park",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#6b9a76"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#38414e"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#212a37"
                        }
                    ]
                },
                {
                    "featureType": "road",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#9ca5b3"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#746855"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "geometry.stroke",
                    "stylers": [
                        {
                            "color": "#1f2835"
                        }
                    ]
                },
                {
                    "featureType": "road.highway",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#f3d19c"
                        }
                    ]
                },
                {
                    "featureType": "transit",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#2f3948"
                        }
                    ]
                },
                {
                    "featureType": "transit.station",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#d59563"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "geometry",
                    "stylers": [
                        {
                            "color": "#17263c"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.fill",
                    "stylers": [
                        {
                            "color": "#515c6d"
                        }
                    ]
                },
                {
                    "featureType": "water",
                    "elementType": "labels.text.stroke",
                    "stylers": [
                        {
                            "color": "#17263c"
                        }
                    ]
                }
            ]
        }
    },

    async mounted() {
        await this.$gmapApiPromiseLazy();
        this.ready = true;
        Vue.nextTick(() => {
            if (this.filtered_deliveries.length > 0) {
                this.center();
            }
        });
        
         setInterval(()=>{
             this.$inertia.reload();
         }, 60 * 1000); // reload it every minute?
    },
    
    computed: {
        territories() {
            let buttons = {};
            let names = {};
            this.deliveries.forEach(delivery => {
                names[delivery.territory.id] = delivery.territory;
                if (!buttons[delivery.territory.id]) {
                    buttons[delivery.territory.id] = 0;
                }
                buttons[delivery.territory.id]++;
            });

            let output = [];
            for (const i in names) {
                const territory = names[i];
                output.push({name: territory.name + " (" + buttons[territory.id] + ")", id: territory.id })
            }
            console.log(output);
            return output;
            
        },
        filtered_deliveries() {
            return this.deliveries.filter(d => this.selected_territory === null || d.territory.id === this.selected_territory)
        }
    },

    methods: {
        
        selectTerritory(territory) {
          
            this.selected_territory = territory;
            this.center();
            
        },
        
        center() {

            console.log("center");
            try {
                if (!google) {
                    return;
                }
            } catch (e) {
                console.log("failed");
                return;
            }
            
            let latlngbounds = new google.maps.LatLngBounds();
            
            this.filtered_deliveries.forEach(d => {
                latlngbounds.extend(d.customer.position);
               latlngbounds.extend(d.restaurant.position);
            })
            
            if (this.$refs.mapRef) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    map.fitBounds(latlngbounds);
                });
            }
        },

        selectDelivery(delivery) {
            
            this.confirming = false;

            this.lines.forEach(line => line.setMap(null));
            this.lines = [];
            this.selected_delivery = delivery;

            this.height = delivery ? "200px" : window.innerHeight + "px";

            if (this.$refs.mapRef) {
                this.$refs.mapRef.$mapPromise.then((map) => {
                    if (delivery) {
                        this.previous_bounds = {
                            center: map.getCenter(),
                            zoom: map.getZoom()
                        }


                        if (delivery.routing) {
                            if (delivery.routing.routes.length === 0 || delivery.routing.routes[0].legs.length === 0) {
                                return;
                            }
                            this.lines = RoutePlotter(delivery.routing.routes[0].legs[0].steps, map)
                            
                        }

                        let bounds = new google.maps.LatLngBounds();
                        bounds.extend(delivery.customer.position);
                        bounds.extend(delivery.restaurant.position);
                        map.fitBounds(bounds);


                    } else {

                        map.setCenter(this.previous_bounds.center);
                        map.setZoom(this.previous_bounds.zoom);

                    }

                });

            }
        
        },
        
        distance(meters) {
            if (meters < 1000) {
                return meters + "m";
            }
            return (meters/1000).toFixed(2) + "km";
        },

        conf() {
            if (this.confirming) {
                this.$inertia.post(this.$route('driver.delivery.snipe', {driver: this.driver.id, delivery: this.selected_delivery.id}), this.extras, {
                    onSuccess: () => {
                        this.confirming = false;
                        this.selectDelivery(null);
                    }
                })
            } else {
                this.confirming = true;
            }
        },
        marker_label(delivery) {
            if (delivery.status !== 'pending') {
                return null;
            }
            return {text:`${delivery.placedtime}`, color: '#ffffff', fillColor: '#0000ff'};
        },
        marker_icon(delivery) {
            try {
                if (!google) {
                    return null;
                }
            } catch (e) {
                return null;
            }
            
            if (delivery.status === 'pending') {
                //    return null;
            }

            let color = '#cccccc';
            switch (delivery.status) {
                case 'grabbed':
                    color = '#4CAF50';
                    break;
                case 'preparing':
                    color = '#ffe135';
                    break;
                case 'ready':
                    color = '#1e4d2b';
                    break;
                case 'pending':
                    
                    color = this.interpolateColor([204, 204, 204], [255, 0, 0], delivery.placedtime > 50 ? 1 : delivery.placedtime/50)
                    //
                    // if (delivery.placedtime > 50) {
                    //     color = '#ff0000';
                    // } else if (delivery.placedtime > 15) {
                    //     color = '#ff5500';
                    // }
                    break;
            }


            return {
                path: "M18.1422 16.1421L12.2843 22L6.42637 16.1421C5.26781 14.9835 4.47882 13.5074 4.15918 11.9004C3.83953 10.2934 4.0036 8.62774 4.63062 7.11399C5.25764 5.60025 6.31945 4.30643 7.68179 3.39614C9.04413 2.48586 10.6458 2 12.2843 2C13.9227 2 15.5244 2.48586 16.8868 3.39614C18.2491 4.30643 19.3109 5.60025 19.9379 7.11399C20.565 8.62774 20.729 10.2934 20.4094 11.9004C20.0897 13.5074 19.3007 14.9835 18.1422 16.1421ZM12.2843 12.1251C12.7725 12.1251 13.2408 11.9312 13.586 11.5859C13.9313 11.2407 14.1252 10.7724 14.1252 10.2842C14.1252 9.79595 13.9313 9.3277 13.586 8.98245C13.2408 8.63721 12.7725 8.44325 12.2843 8.44325C11.796 8.44325 11.3278 8.63721 10.9825 8.98245C10.6373 9.3277 10.4433 9.79595 10.4433 10.2842C10.4433 10.7724 10.6373 11.2407 10.9825 11.5859C11.3278 11.9312 11.796 12.1251 12.2843 12.1251Z",
                fillColor: color,
                fillOpacity: 1,
                anchor: new google.maps.Point(
                    12, // width
                    12 // height
                ),
                strokeWeight: 1,
                strokeColor: "#ffffff",
                scale: 1.2,
            };

        },


        interpolateColor(color1, color2, factor) {
            
            var result = color1.slice();
            for (var i = 0; i < 3; i++) {
                result[i] = new Number(Math.round(result[i] + factor * (color2[i] - color1[i]))).toString(16);
                if (`${result[i]}`.length === 1) {
                    result[i] = '0' + result[i]
                }
            }
            return "#" + result.join("");
        }

    }

}
</script>

<style scoped>

</style>
